import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';

@Injectable()
export class NoticeBoardNotificationDeleteService {

    constructor(
        private readonly httpClient: HttpClient,
        private readonly urlBuilderService: UrlBuilderService) {
      }
    
    deleteNoticeBoardNotification(noticeBoardNotificationUri: number) {
      const url = this.urlBuilderService.getUrl(`DeleteNoticeBoardNotification/DeleteNotification/${noticeBoardNotificationUri}`) ;
      return this.httpClient.delete(url);
    }
}
